/* eslint-disable prettier/prettier */
import { Box, Typography } from "@mui/material";
import { clsx } from "clsx";
import useStyles from "../Styles";

interface CountProps {
  count: number;
}
const Count: React.FC<CountProps> = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.infoBox}>
      <Box className={classes.infoText}>
        <Box className={clsx(classes.square, classes.backgroundPersonal)} />
        <Typography className={classes.title}>My Responses</Typography>
      </Box>
      <Box className={classes.infoText}>
        <Box className={clsx(classes.square, classes.backgroundGeneric)} />
        <Typography className={classes.title}>Generic Responses</Typography>
      </Box>
    </Box>
  );
};

export default Count;
